import { useEffect } from 'react';
import { useCanvasWebSocket } from '../hooks/useCanvasWebSocket';

export default function EmbedPage() {
  const { canvas } = useCanvasWebSocket();

  // Ensure no scrollbars in OBS
  useEffect(() => {
    // Remove any margins/padding and prevent overflow on body and html
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    
    return () => {
      // Restore defaults when component unmounts
      document.body.style.margin = '';
      document.body.style.padding = '';
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    };
  }, []);

  if (!canvas) {
    return (
      <div className="w-screen h-screen flex items-center justify-center bg-transparent overflow-hidden m-0 p-0">
        <p className="text-sm text-muted-foreground">Lädt...</p>
      </div>
    );
  }

  return (
    <div 
      className="w-screen h-screen flex items-center justify-center overflow-hidden m-0 p-0"
      style={{ background: 'transparent' }}
    >
      <svg 
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid meet"
        style={{ 
          display: 'block', 
          width: '100%', 
          height: '100%',
          maxWidth: '100vw',
          maxHeight: '100vh'
        }}
      >
        {canvas.pixels.map((row, y) =>
          row.map((color, x) => (
            <rect
              key={`${x}-${y}`}
              x={x}
              y={y}
              width={1}
              height={1}
              fill={color}
            />
          ))
        )}
      </svg>
    </div>
  );
}

